import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

interface Params {
  name: string;
  risk_level?: "low" | "medium" | "high";
}
export const useCreateEntityType = () => {
  const { authHeader } = useAuth();

  return useMutation((params: Params) => {
    return axios.post(
      `${env.verifyServiceUrl}individual/entity_type/`,
      params,
      {
        headers: {
          Authorization: authHeader,
        },
      }
    );
  });
};
